<div class="container">
    <div class="main-title" [class.mobile]="isMobile">{{'Disponibilités' | translate}}</div>
    <div class="calendar-container" *ngIf="events" [class.mobile]="isMobile">
        <app-calendar [locale]="locale" [events]="events" (eventSelect)="updateEvent($event, updateEventTemplate)"
            (daySelect)="newEvent($event, updateEventTemplate)">
        </app-calendar>
    </div>
</div>

<ng-template #updateEventTemplate>
    <div class="modal-content">
        <div class="header">
            <span *ngIf="!eventModel.id">Add</span><span *ngIf="eventModel.id">Edit</span> Event
            <div class="close" (click)="close()">
                <i class="fa fa-times"></i>
            </div>
        </div>
        <div class="content">
            <div class="form">
                <div class="form-group">
                    <div class="label">Name</div>
                    <input type="text" required id="name" [(ngModel)]="eventModel.name" #name="ngModel" />
                    <div *ngIf="name.invalid && (name.dirty || name.touched)">
                        Name is required
                    </div>
                </div>
                <div class="form-group">
                    <div class="label">Start date</div>
                    <p-calendar [(ngModel)]="eventModel.from" dateFormat="dd/mm/yy" appendTo="body"></p-calendar>
                </div>
                <div class="form-group">
                    <div class="label">End date</div>
                    <p-calendar [(ngModel)]="eventModel.to" dateFormat="dd/mm/yy" appendTo="body"></p-calendar>
                </div>
                <div class="form-group">
                    <div class="label">Type</div>
                    <select [(ngModel)]="eventModel.type">
                        <option *ngFor="let reservationType of reservationTypeKeys"
                            [value]="ReservationType[reservationType]">
                            {{reservationType}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="footer">
            <button class="wire-btn" (click)="saveEvent()">Save</button>
            <button *ngIf="eventModel.id" class="wire-btn" (click)="deleteEvent()">Delete</button>
            <button class="wire-btn default" (click)="close()">Cancel</button>
        </div>
    </div>
</ng-template>

<p-confirmDialog header="Delete Event" icon="pi pi-exclamation-triangle"></p-confirmDialog>